import { partial } from 'io-ts/Decoder';

import { Id as OrganizationId } from '../../../../organization/Id';

export const Params = partial({
	organizationId: OrganizationId,
});
